import script from "./Live.vue?vue&type=script&lang=ts&setup=true"
export * from "./Live.vue?vue&type=script&lang=ts&setup=true"

import "./Live.vue?vue&type=style&index=0&id=d2e62ce2&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2e62ce2"]])

export default __exports__